module.exports = __webpack_public_path__ + "static/media/sign-up.85a0058b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/video-thumbnails/sign-up.png
// module id = 2169
// module chunks = 0